<template>
 <div class="help-fourth-page">
  <div :class="lang === 'en' ? 'help-sixth-page-image-content-en' : 'help-sixth-page-image-content'" ></div>
  <div class="help-text-content-sixth-lower" data-langname="lb_help_6">
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      lang: this.$route.query.lang
    };
  }
}
</script>